import React from "react";
import { string, oneOfType, number, objectOf, shape, oneOf, func } from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../sharedComponents/Card";
import { Icon } from "../../Icons/Icons";
import * as styles from "./QuinaryCard.module.scss";

const QuinaryCard = ({ icon, header, subheader, content, buttons, className, style }) => (
	<Card className={cx(styles.quinary, className)} style={style}>
		<Card.BodyContainer className={cx(styles.contentContainer)}>
			<div className={cx(styles.headingContainer)}>
				{icon && <Icon name={icon} className={`swg-text-6xl ${cx(styles.qIcon)}`} />}
				<div className={cx(styles.headingsContainer)}>
					<Card.Header>{header}</Card.Header>
					{subheader && <Card.Subheader>{subheader}</Card.Subheader>}
				</div>
			</div>
			{content && <Card.Content>{content}</Card.Content>}
			{buttons && (
				<div className={styles.btnWrapper}>
					{buttons.map((button, idx) => (
						<Card.Button
							className={styles.btn}
							outline={idx > 0}
							label={button.text}
							icon={button.icon}>
							{button.text}
						</Card.Button>
					))}
				</div>
			)}
		</Card.BodyContainer>
	</Card>
);

QuinaryCard.propTypes = {
	icon: string,
	header: string.isRequired,
	subheader: string,
	content: string,
	buttons: shape({
		icon: string,
		iconPlacement: oneOf(["right", "left"]),
		onClick: func,
		label: string,
	}).isRequired,
	className: string,
	style: objectOf(oneOfType([string, number])),
};

QuinaryCard.defaultProps = {
	icon: null,
	subheader: "",
	content: "",
	className: "",
	style: {},
};

export default QuinaryCard;
export { QuinaryCard };
